import axios from 'axios'

export const axiosInstance = axios.create({
    baseURL: window.configs.api_url + "/v1",
    withCredentials: true
})